import { Box, Card, CircularProgress, Divider, Typography } from '@mui/material'
import React, { Fragment, useCallback, useEffect, useState } from 'react'
import UserLayout from '../../layouts/UserLayout'
import { api } from '../../utils/api'
import axios from 'axios'
import { handleError } from '../../utils/error'
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { currentUserActions } from '../../redux/store'
import { getFromStorage } from '../../utils/storage'
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp'
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown'
import { mainGreen, mainRed } from '../../utils/color'

export default function ImportExportHistory() {
	const dispatch = useDispatch()
	const navigate = useNavigate()
	const token = getFromStorage('current-user')?.accessToken
	const [loadingSearch, setLoadingSearch] = useState(true)

	const [products, setProducts] = useState([])

	const getProducts = useCallback(
		async function () {
			try {
				const response = await axios({
					url: api.GET_STOCK_HISTORY,
					method: 'GET',
					headers: {
						Authorization: `Bearer ${token}`,
					},
				})
				setProducts(response.data)
				setLoadingSearch(false)
			} catch (err) {
				handleError(err)
				dispatch(currentUserActions.isLogout())
				navigate('/login')
			}
		},
		[dispatch, navigate, token],
	)

	useEffect(() => {
		getProducts()
	}, [getProducts])

	return (
		<UserLayout>
			{loadingSearch ? (
				<Box display='flex' justifyContent='center' sx={{ marginTop: '120px' }}>
					<CircularProgress sx={{ color: mainGreen }} />
				</Box>
			) : (
				<Card
					sx={{
						padding: '20px 20px 10px 20px',
						background: '#fff',
					}}>
					{products?.map((prod, index) => {
						return (
							<Fragment key={index}>
								{prod.action === 'import' && (
									<>
										<Box display='flex' alignItems='flex-start'>
											<ArrowDropUpIcon sx={{ fontSize: '20px', color: mainGreen }} />
											<Typography>
												<span style={{ color: mainGreen, fontWeight: 'bold' }}>(+{prod.quantity})</span> nhập từ{' '}
												<b>{prod.user?.name}</b>.{' '}
												{prod.note && <span style={{ fontStyle: 'italic' }}>({prod.note}).</span>}{' '}
												<span>
													Tồn: <b>{Number(prod.balance)?.toFixed(1)}</b>kg
												</span>
											</Typography>
										</Box>
										<Typography
											style={{
												fontStyle: 'italic',
												fontSize: '12px',
												textAlign: 'right',
												marginTop: '3px',
											}}>
											- {prod.timeStamp} -
										</Typography>{' '}
										<Divider sx={{ mb: 1 }} />
									</>
								)}
								{prod.action === 'export' &&
									(prod.request.status === 'approved' ||
										prod.request.status === 'confirm' ||
										prod.request.status === 'complete') && (
										<>
											<Box display='flex' alignItems='flex-start'>
												<ArrowDropDownIcon sx={{ fontSize: '20px', color: mainRed }} />
												<Typography>
													<span style={{ color: mainRed, fontWeight: 'bold' }}>(-{prod.quantity})</span>{' '}
													<b>{prod.user?.name}</b> xuất cho <b>{prod.request.store?.name}</b>.{' '}
													{prod.note && <span style={{ fontStyle: 'italic' }}>({prod.note}).</span>}{' '}
													<span>
														Tồn: <b>{Number(prod.balance)?.toFixed(1)}</b>kg
													</span>
												</Typography>
											</Box>
											<Typography
												style={{
													fontStyle: 'italic',
													fontSize: '12px',
													textAlign: 'right',
													marginTop: '3px',
												}}>
												- {prod.timeStamp} -
											</Typography>{' '}
											<Divider sx={{ mb: 1 }} />
										</>
									)}
							</Fragment>
						)
					})}
				</Card>
			)}
		</UserLayout>
	)
}
